__turbopack_context__.v({
  "search_pagination_list": "SearchPaginationList-module-scss-module__PweBFq__search_pagination_list",
});
